import EmpHeaderSection from "../app/pannels/employer/common/emp-header";
import EmpSidebarSection from "../app/pannels/employer/common/emp-sidebar";
import YesNoPopup from "../app/common/popups/popup-admin-yes-no";
import EmployerRoutes from "../routing/employer-routes";
import { popupType } from "../globals/constants";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { publicUser } from "../globals/route-names";
import { useTranslation } from "react-i18next";

function EmployerLayout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [sidebarActive, setSidebarActive] = useState(true);
    const handleSidebarCollapse = () => {
        setSidebarActive(!sidebarActive);
    }

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            navigate(publicUser.pages.ADMIN_LOGIN);
        }
    }, [navigate]);

    return (
        <>
            <div className="page-wraper">

                <EmpHeaderSection onClick={handleSidebarCollapse} sidebarActive={sidebarActive} />
                <EmpSidebarSection sidebarActive={sidebarActive} />

                <div id="content" className={sidebarActive ? "" : "active"}>
                    <div className="content-admin-main">
                        <EmployerRoutes />
                    </div>
                </div>

                <YesNoPopup id="delete-dash-profile" type={popupType.DELETE} msg={"Do you want to delete your profile?"} />
                <YesNoPopup id="logout-dash-profile" type={popupType.LOGOUT} msg={`${t("Do you want to Logout your profile?")}`} />

            </div>
        </>
    )
}

export default EmployerLayout;